import { Col, Container, Row } from 'react-bootstrap';

import Column from '../../layouts/Column';
import RecentReports from './components/RecentReports';
import ThoughtLeadership from './components/ThoughtLeadership';
import Welcome from './components/Welcome';

const Home = () => {
  return (
    <Column>
      <Welcome />
      <Container>
        <Row>
          <Col xs={6}>
            <RecentReports />
          </Col>
          <Col xs={6}>
            <ThoughtLeadership />
          </Col>
        </Row>
      </Container>
    </Column>
  );
};
export default Home;
